import { Component, OnInit, Inject, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import swal from "sweetalert2";
import { Paginator } from "primeng/paginator";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { AccessToken as MyAccessToken } from "@app/util/accessToken";
import { environment } from "@env/environment";
import { LinkShareComponent } from "@app/shared/components/link-share/link-share.component";
declare var $: any;
import * as _ from 'lodash';
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { ConnectMiniProfileComponent } from "@app/shared/components/connect-mini-profile/connect-mini-profile.component";
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { Subscription } from "rxjs/Subscription";
import { debounceTime , distinctUntilChanged, switchMap, map, filter} from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { LoaderService } from "@app/shared/services/loader.service";
@Component({
  selector: "app-social-feed",
  templateUrl: "./social-feed.component.html",
  styleUrls: ["./social-feed.component.css"]
})
export class SocialFeedComponent implements OnInit, OnDestroy {
  @ViewChild('paginatorId') paginator = new Paginator();
  @ViewChild(ConnectMiniProfileComponent) connectionMini: ConnectMiniProfileComponent;
  @ViewChild(LinkShareComponent) linkShareModal: LinkShareComponent;
  @ViewChild('searchInput') searchInput : ElementRef;
  @ViewChild('filterInput') filterInput : ElementRef;

  userDetailsObject;
  socialFeedData: any = [];
  addCommentForm: FormGroup;
  userRole;
  analystData: object;
  loggedInStatus: boolean;
  userId: string = "";
  blogURL: string;
  wpAutoLoginUrl: string = '';
  dataLimit = 9;
  skipValue = 0;
  filterKeyId: string;

  techDomainListData: any;

  // search
  techDomainListselected: string;
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  subscription: Subscription;
  totalCount: number;
  constructor(
    public rolesSharedService: RolesSharedService,
    private formBuilder: FormBuilder,
    private router: Router,
    private breadcrumService: BreadcrumService,

    private authenticationService: AuthenticationService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private likeModalService: LikeModalServiceService,
    private myAccessToken: MyAccessToken,
    @Inject(DOCUMENT) private document: Document,
    private techDomainService: TechDomainService,
    private loaderService: LoaderService
  ) {
    this.blogURL = environment.BLOG_URL;
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {
    this.userDetails();
    this.getRole();
    this.analystDatafunc();
    this.getDomainList();
    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;
    this.socialFeedDataObject();
    // this.getSocialFeedData();
    // this.createCommentForm();

    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.userDetails();
        if (this.loggedInStatus) {
          this.techDomainListselected = newSelectedIds;
          this.applyFilter();
        }
    });
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      // ,filter(res => res.length > 2)
      // Time in milliseconds between key events
      ,debounceTime(1000)        
      // If previous query is diffent from current   
      ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchString = text;
        this.dataLimit = 9;
        this.skipValue = 0;
        if (this.paginator) {
          this.paginator.first = 0;
        }
        this.socialFeedData = [];
        this.socialFeedDataObject();
      });
      fromEvent(this.filterInput.nativeElement, 'change').pipe(
        // get value
        map((event: any) => {
          return this.techDomainListselected;
          // return event.target.value;
        })
        // if character length greater then 2
        // ,filter(res => res.length > 2)
        // Time in milliseconds between key events
        ,debounceTime(1000)        
        // If previous query is diffent from current   
        ,distinctUntilChanged()
        // subscription for response
        ).subscribe((text: string) => {
          this.filterKeyId = text;
          // this.allResearchData = [];
          this.applyFilter();
        });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.loggedInStatus = true;
      this.userId = this.userDetailsObject.userId;
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  analystDatafunc() {
    const analystListFilter: any = {};
    analystListFilter.filter = JSON.stringify({
      limit: 10,
      skip: 0
    });
    this.rolesSharedService
      .getAnalystListDetails(analystListFilter)
      .subscribe((analystList: any) => {
        this.analystData = analystList;
      });
  }

  followAnalyst(AnalystData, index) {
    const filter: any = {}
    filter.filter = JSON.stringify({
      analystUserId: AnalystData.id,
      followerUserId: this.userId
    })

    this.rolesSharedService.analystFollow(filter.filter).subscribe(
      followResponse => {
        if (followResponse["followed"]) {
          // case when user is liked and updated in server
          AnalystData.isFollow = true;
          AnalystData.followerCount += 1;
        } else if (!followResponse["followed"]) {
          // case when user is not liked and updated in server
          AnalystData.isFollow = false;
          AnalystData.followerCount -= 1;
        }
      });
  }

  onScrollDown() {
    this.skipValue = this.skipValue + 9;
    if (this.totalCount > this.skipValue) {
      this.socialFeedDataObject();
    }
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {
      this.techDomainListData = data;
    });
  }

  applyFilter() {
    this.dataLimit = 9;
    this.skipValue = 0;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.socialFeedData = [];
    this.socialFeedDataObject();
  }

  socialFeedsFilter() {
    const filter: any = {};
    filter.sort = JSON.stringify({ "postDate": "DESC" });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    if (this.techDomainListselected) {
      filter.techDomainId = this.techDomainListselected;
    }
    return filter;
  }

  socialFeedDataObject() {
    let searchKey = this.searchString;
    let filterKey = this.filterKeyId;
    this.rolesSharedService.getSocialFeedList(this.socialFeedsFilter()).subscribe(
      (response: any) => {
        if ((searchKey === this.searchString) && (filterKey === this.filterKeyId)) {
        this.loaderService.display(false);
        this.totalCount = response.totalCount;
        this.socialFeedData = _.uniqWith([...this.socialFeedData, ...response.data], _.isEqual);
      }
      },
      error => {

      }
    );
  }

  socialFeedLike(postData: any) {
    if (postData.postType === 'comment' || postData.postType === 'like') {
      this.likeClick(postData, postData.itemType);
    }
    else {
      this.likeClick(postData, postData.postType);
    }
  }

  likeClick(postData: any, documentType: string) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
    // like button click
    if (this.loggedInStatus && this.userDetailsObject) {
      if (this.userDetailsObject.nickName) {
        const dataBody = {
          postId: postData.postId,
          postType: documentType,
          userId: this.userId
        };

        this.rolesSharedService
          .addLike(JSON.stringify(dataBody))
          .subscribe(likeResponse => {
            if (likeResponse["liked"]) {
              // case when user is liked and updated in server
              postData.isLiked = true;
              postData.likeCount += 1;
              this.rolesSharedService.logLikeInMixpanel(dataBody.postType, postData.title);
            } else if (!likeResponse["liked"]) {
              // case when user is not liked and updated in server
              postData.isLiked = false;
              if (postData.likeCount != 0) {
                postData.likeCount -= 1;
              }
            }
          });
      } else {

        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  openCommentModal(data: any) {
    this.userDetailsObject = JSON.parse(
      window.sessionStorage.getItem("userDetails")
    );
    if (this.loggedInStatus && this.userDetailsObject.nickName) {
      this.commentModalService.modalStatus(true, data);
    }
    else {
      this.nickNameModalService.openNickNameModal();
    }
  }

  populateComments(post) {
    if (this.userDetailsObject.nickName) {
      post.showComments = !post.showComments;
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  openLikeModal(data) {
    if (this.loggedInStatus) {
      data.id = data.postId;
      this.likeModalService.modalStatus(true, data);
    }
  }

  navigateToPage(feedData) {
    if (feedData.postType === 'comment' || feedData.postType === 'like') {
      this.feedNavidgation(feedData.itemType, feedData);
    }
    else {
      this.feedNavidgation(feedData.postType, feedData);
    }
  }

  feedNavidgation(type, feedData) {
    if (feedData.title) {
      this.breadcrumService.setUrl('BC3Label', feedData.title);
    } else {
      this.breadcrumService.setUrl('BC3Label', feedData.researchDocumentName);
    }
    if (this.userRole === 'tech-analyst' && type === 'report') {
      type = 'report-analyst';
    }
    sessionStorage.setItem('analystName', feedData.firstName + ' ' + feedData.lastName);

    switch (type) {
      case 'analyst': this.breadcrumService.setUrl('BC3Label', feedData.firstName + ' ' + feedData.lastName);
        this.router.navigate([`analyst-profile`], { queryParams: { analystId: feedData.postId } }); break;
      case 'tech_domain': break;
      case 'research_document':
        this.breadcrumService.setUrl('BC3Label', feedData.researchDocumentName || feedData.title);
        if (this.userRole === 'tech-vendor') {
          this.router.navigate([`${this.userRole}/market-data/${feedData.postId}`]);
        } else {
          this.router.navigate([`${this.userRole}/research-snapshot/${feedData.postId}`]);
        } 
        break;
      case 'report-analyst':
        this.breadcrumService.setUrl('BC3Label', feedData.title);
        this.router.navigate([`${this.userRole}/reports/report-details/${feedData.postId}`]); break;

      case 'report':
        this.breadcrumService.setUrl('BC3Label', feedData.title);
        this.router.navigate([`${this.userRole}/report-details/${feedData.postId}`]); break;
      case 'admin_social_announcement': break;
      case 'follow':
        this.breadcrumService.setUrl('BC3Label', feedData.firstName + ' ' + feedData.lastName);
        this.router.navigate([`analyst-profile`], { queryParams: { analystId: feedData.postId } }); break;
      case 'blog': this.navtoFeedBlog(feedData.ID); break;
      case 'like': this.navRoute(feedData); break;
      case 'comment': this.navRoute(feedData); break;
      default: break;
    }
  }

  trendingResearchListNavigate() {
    this.router.navigate([`${this.userRole}/research/trending-research`]);
  }

  analystListNavigate() {
    this.router.navigate([`${this.userRole}/analyst-list`]);
  }

  reportsNavigate() {
    this.router.navigate([`${this.userRole}/reports`]);
  }

  blogsNavigate() {
    this.router.navigate([`${this.userRole}/blogs`]);
  }

  featureUnderConstructionNavigation() {
    this.router.navigate([`${this.userRole}/under-construction`]);
  }

  routeTechAnalystProfilePage(roleCode, analystId: string, name) {
    if (roleCode === 'tech_analyst') {
      // sessionStorage.setItem('sheduleCallUrl', `${this.userRole}/social-feeds`);
      // sessionStorage.setItem('sheduleCallLabel', `Social Feed`);
      // this.breadcrumService.setUrl('BC3Label',feedData.title);
      // sessionStorage.removeItem('analystList');
      this.breadcrumService.setUrl('BC3Label', name);
      this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
    }
  }
  routeTechAnalystProfilePageSide(analystId: string, name) {
    // sessionStorage.setItem('sheduleCallUrl', `${this.userRole}/social-feeds`);
    // sessionStorage.setItem('sheduleCallLabel', `Social Feed`);
    // sessionStorage.setItem('analystName', name);
    this.breadcrumService.setUrl('BC3Label', name);
    // sessionStorage.removeItem('analystList');

    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }
  navRoute(data?: any) {
    if (data.postType == 'like' && data.itemType == 'report') {
      this.router.navigate([`${this.userRole}/report-details/${data.postId}`]);
    } else if (data.postType == 'comment' && data.itemType == 'report') {
      this.router.navigate([`${this.userRole}/report-details/${data.postId}`]);
    }
    else if (data.postType == 'like' && data.itemType == 'research_document') {
      if (this.userRole === 'tech-vendor') {
        this.router.navigate([`${this.userRole}/market-data/${data.postId}`]);
      } else {
        this.router.navigate([`${this.userRole}/research-snapshot/${data.postId}`]);
      }
    }
    else if (data.postType == 'comment' && data.itemType == 'research_document') {
      if (this.userRole === 'tech-vendor') {
        this.router.navigate([`${this.userRole}/market-data/${data.postId}`]);
      } else {
        this.router.navigate([`${this.userRole}/research-snapshot/${data.postId}`]);
      }
      
    }
    else if (data.postType == 'follow' && !data.itemType) {
      this.router.navigate([
        'analyst-profile', {
          analystId: `${data.postId}`
        }]);
    }
  }
  navtoBlogs() {
    let token = this.myAccessToken.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}`;
      window.open(blogUrl, '_self');
    }
    else {
      window.open(this.blogURL, '_self');
    }
  }
  navtoFeedBlog(id?: any) {
    let token = this.myAccessToken.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&id=${id}`;
      window.open(blogUrl, '_self');
    }
    else {
      window.open(this.blogURL, '_self');
    }
  }
  shareLink(data) {
    if (data.postType === 'like' || data.postType === 'comment') {
      this.showShareModal(data.itemType, data);
    }
    else {
      this.showShareModal(data.postType, data);
    }

  }
  showShareModal(type, data) {
    if (type === 'report') { // report
      this.linkShareModal.showModal('report', data);
    } else if (type === 'research_document') { // research_document
      this.linkShareModal.showModal('research', data);
    } else if (type === 'analyst') { // analyst
      this.linkShareModal.showModal('analyst', data);
    } else { // social_feed
      this.linkShareModal.showModal('social_feed', data);
    }
  }
  showUserDetails(data){
    if(data && data.code ==='tech_analyst'){
      const fullName = data.firstName + '' +data.lastName;
      this.routeTechAnalystProfilePageSide(data.id,fullName);
    }
    else if(data && data.code && data.code !=='super_admin' ) {
      this.connectionMini.getProfileData(data.id);
    }
    else if(data && (data.postType ==='analyst' || data.itemType ==='analyst')) {
      const fullName = data.title;
      this.routeTechAnalystProfilePageSide(data.postId,fullName);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/social-feed/social-feed.component.ts